import { PotIllustration } from "@/app/components/PotIllustration";
import { potCoverPhotoUrl } from "@/app/lib/plant-image";
import type { Pot } from "@/types";

/** Rounded-square photo footprint per size, matched to the illustration's scale. */
const PHOTO_PX: Record<"small" | "normal", number> = { small: 56, normal: 72 };

/**
 * A pot's visual: the lone plant's photo when the pot borrows it as a cover
 * (see {@link potCoverPhotoUrl}), otherwise the procedural pot illustration.
 */
export function PotCover({ pot, size = "normal" }: Readonly<{
  pot: Pot;
  size?: "small" | "normal";
}>) {
  const coverPhoto = potCoverPhotoUrl(pot);
  if (coverPhoto) {
    const px = PHOTO_PX[size];
    return (
      <img
        src={coverPhoto}
        alt=""
        className="block object-cover rounded-[14px]"
        style={{ width: px, height: px }}
      />
    );
  }
  return <PotIllustration shape={pot.shape} plants={pot.plants} size={size} />;
}
